import { displayError } from '../helpers';
import { printDebitNote } from '../services/DebitNoteServices';
import { openPdfInApp } from './openPdfInApp';

async function parseApiError(error) {
    const responseData = error?.response?.data;
    if (responseData instanceof Blob) {
        try {
            const text = await responseData.text();
            try {
                return JSON.parse(text);
            } catch (parseError) {
                return { message: text || 'Failed to generate Debit Note PDF.' };
            }
        } catch (readError) {
            return { message: 'Failed to generate Debit Note PDF.' };
        }
    }
    return responseData || error;
}

export function fetchAndShowDebitNotePdf(cookies, debitNoteId, options = {}) {
    return printDebitNote(cookies, debitNoteId)
        .then((pdfResponse) => {
            openPdfInApp(pdfResponse, {
                title: options.title || 'Debit Note PDF',
                onClose: options.onClose,
            });
        })
        .catch(async (error) => {
            const parsedError = await parseApiError(error);
            displayError(parsedError || { message: 'Failed to generate Debit Note PDF.' }, options.errorTitle || 'Print Failed');
        });
}
